// @flow
export { default } from './ScrollToError';
export type { Props } from './ScrollToError';



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/ScrollToError/index.js